import PaymentSummeryView from "./paymentSummery.jsx";
import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";

const PaymentSummery = () => {
    const history = useHistory();
    const paymentData = JSON.parse(localStorage.getItem('paymentData'))

    useEffect(() => {
        let token = JSON.parse(localStorage.getItem('token'));
        if (!token) {
            history.push("/");
        }
    })

    const clickContinue = () => {
        const adminToken = localStorage.getItem('adminOldToken');

        let flowName = localStorage.getItem('AdminFlow');
        if (flowName === 'institute' || flowName === 'expert') {

            let comingFromInstitute = localStorage.getItem("comingFromInstitute")
            if (comingFromInstitute && comingFromInstitute) {
                let oldToken = localStorage.getItem("instituteExpertToken")
                localStorage.setItem("token", oldToken);
                localStorage.removeItem("instituteExpertToken");
                localStorage.setItem('flowName', 'institute')
                localStorage.setItem('flowType', 'institute')
                localStorage.removeItem("adInsExpert");
                localStorage.removeItem("paymentData");
                localStorage.removeItem("instituteExpert");

                window.location.href = '/dashBoard'
                localStorage.removeItem("comingFromInstitute");

            }
            else {

                localStorage.setItem("token", JSON.stringify(adminToken));
                localStorage.removeItem("AdminFlow")
                // localStorage.removeItem("adminOldToken")
                // localStorage.removeItem("loginData")
                localStorage.removeItem("expertId")
                localStorage.removeItem("instituteId")
                localStorage.removeItem("instituteExpert");
                localStorage.removeItem("adInsExpert");

                localStorage.removeItem("instituteExpertToken");
                window.location.href = '/admin/opsDashboardHome'
                localStorage.setItem('flowName', 'admin')
                localStorage.setItem('flowType', 'admin')
            }

        } else {

            localStorage.removeItem("token");
            localStorage.removeItem("auth");
            localStorage.removeItem("masterID");
            localStorage.removeItem("token");
            localStorage.removeItem("paymentData")
            window.location.href = '/'
        }
    }

    return (
        <PaymentSummeryView
            paymentData={paymentData}
            clickContinue={clickContinue}
        />
    )
}

export default PaymentSummery;